/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { BillingProvisioningRequestPatchSpec } from '../model/billingProvisioningRequestPatchSpec';
// @ts-ignore
import { BillingProvisioningRequestPostSpec } from '../model/billingProvisioningRequestPostSpec';
// @ts-ignore
import { ProvisioningNotificationBulkResponse } from '../model/provisioningNotificationBulkResponse';
// @ts-ignore
import { ProvisioningNotificationPaginatedResponse } from '../model/provisioningNotificationPaginatedResponse';
// @ts-ignore
import { ProvisioningNotificationResponse } from '../model/provisioningNotificationResponse';
// @ts-ignore
import { ProvisioningNotificationSourceTypeEnum } from '../model/provisioningNotificationSourceTypeEnum';
// @ts-ignore
import { ProvisioningNotificationStatusEnum } from '../model/provisioningNotificationStatusEnum';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class BillingProvisioningOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Create provisioning notification
     * Create a new provisioning notification
     * @param billingProvisioningRequestPostSpec Provisioning request post spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createProvisioningNotificationBillingOperator(billingProvisioningRequestPostSpec: Array<BillingProvisioningRequestPostSpec>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<ProvisioningNotificationBulkResponse>;
    public createProvisioningNotificationBillingOperator(billingProvisioningRequestPostSpec: Array<BillingProvisioningRequestPostSpec>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProvisioningNotificationBulkResponse>>;
    public createProvisioningNotificationBillingOperator(billingProvisioningRequestPostSpec: Array<BillingProvisioningRequestPostSpec>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProvisioningNotificationBulkResponse>>;
    public createProvisioningNotificationBillingOperator(billingProvisioningRequestPostSpec: Array<BillingProvisioningRequestPostSpec>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (billingProvisioningRequestPostSpec === null || billingProvisioningRequestPostSpec === undefined) {
            throw new Error('Required parameter billingProvisioningRequestPostSpec was null or undefined when calling createProvisioningNotificationBillingOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/provisioning-notification`;
        return this.httpClient.request<ProvisioningNotificationBulkResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: billingProvisioningRequestPostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete provisioning notification by id or saas_transaction_id
     * Delete provisioning notification by id or saas_transaction_id
     * @param id id of the provisioning notification to delete
     * @param saasTransactionId saas transaction id to delete all related provisioning notifications
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteProvisioningNotificationBillingOperator(id?: number, saasTransactionId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<ProvisioningNotificationBulkResponse>;
    public deleteProvisioningNotificationBillingOperator(id?: number, saasTransactionId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProvisioningNotificationBulkResponse>>;
    public deleteProvisioningNotificationBillingOperator(id?: number, saasTransactionId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProvisioningNotificationBulkResponse>>;
    public deleteProvisioningNotificationBillingOperator(id?: number, saasTransactionId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>id, 'id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>saasTransactionId, 'saas_transaction_id');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/provisioning-notification`;
        return this.httpClient.request<ProvisioningNotificationBulkResponse>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get provisioning notifications by filters
     * Get all provisioning notifications by filters
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the provisioning notification by this column
     * @param saasTransactionId transaction identifier in Optional Filter
     * @param action action in Optional Filter
     * @param skuInfoOptionalQuerySku Sku Info Primary Key
     * @param serialNumberQueryParamOptional Subscription Serial Number In Optional Filter
     * @param subscriptionTypeQueryParamOptional Subscription type In Optional Filter
     * @param pla pla in Optional Filter
     * @param startDateStartOptionalQueryParam Start date to begin with in YYYY-MM-DD
     * @param startDateEndOptionalQueryParam Start date to end with in YYYY-MM-DD
     * @param endDateStartOptionalQueryParam End date to begin with in YYYY-MM-DD
     * @param endDateEndOptionalQueryParam End date to end with in YYYY-MM-DD
     * @param erpCustAcctNumber erp customer account number in Optional Filter
     * @param countryCode country code in Optional Filter
     * @param newTenantRequired is new tenant required
     * @param orgId organization identifier in optional filter
     * @param information information in Optional Filter
     * @param status status in Optional Filter
     * @param sourceType source type in Optional Filter
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProvisioningNotificationBillingOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'saasTransactionId' | 'action' | 'sku' | 'serialNumber' | 'subscriptionType' | 'pla' | 'serviceStartDate' | 'serviceEndDate' | 'erpCustAcctNumber' | 'newTenantRequired' | 'tenantId' | 'countryCode' | 'information' | 'status', saasTransactionId?: string, action?: string, skuInfoOptionalQuerySku?: string, serialNumberQueryParamOptional?: string, subscriptionTypeQueryParamOptional?: string, pla?: string, startDateStartOptionalQueryParam?: string, startDateEndOptionalQueryParam?: string, endDateStartOptionalQueryParam?: string, endDateEndOptionalQueryParam?: string, erpCustAcctNumber?: string, countryCode?: string, newTenantRequired?: string, orgId?: string, information?: string, status?: ProvisioningNotificationStatusEnum, sourceType?: ProvisioningNotificationSourceTypeEnum, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<ProvisioningNotificationPaginatedResponse>;
    public getProvisioningNotificationBillingOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'saasTransactionId' | 'action' | 'sku' | 'serialNumber' | 'subscriptionType' | 'pla' | 'serviceStartDate' | 'serviceEndDate' | 'erpCustAcctNumber' | 'newTenantRequired' | 'tenantId' | 'countryCode' | 'information' | 'status', saasTransactionId?: string, action?: string, skuInfoOptionalQuerySku?: string, serialNumberQueryParamOptional?: string, subscriptionTypeQueryParamOptional?: string, pla?: string, startDateStartOptionalQueryParam?: string, startDateEndOptionalQueryParam?: string, endDateStartOptionalQueryParam?: string, endDateEndOptionalQueryParam?: string, erpCustAcctNumber?: string, countryCode?: string, newTenantRequired?: string, orgId?: string, information?: string, status?: ProvisioningNotificationStatusEnum, sourceType?: ProvisioningNotificationSourceTypeEnum, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProvisioningNotificationPaginatedResponse>>;
    public getProvisioningNotificationBillingOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'saasTransactionId' | 'action' | 'sku' | 'serialNumber' | 'subscriptionType' | 'pla' | 'serviceStartDate' | 'serviceEndDate' | 'erpCustAcctNumber' | 'newTenantRequired' | 'tenantId' | 'countryCode' | 'information' | 'status', saasTransactionId?: string, action?: string, skuInfoOptionalQuerySku?: string, serialNumberQueryParamOptional?: string, subscriptionTypeQueryParamOptional?: string, pla?: string, startDateStartOptionalQueryParam?: string, startDateEndOptionalQueryParam?: string, endDateStartOptionalQueryParam?: string, endDateEndOptionalQueryParam?: string, erpCustAcctNumber?: string, countryCode?: string, newTenantRequired?: string, orgId?: string, information?: string, status?: ProvisioningNotificationStatusEnum, sourceType?: ProvisioningNotificationSourceTypeEnum, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProvisioningNotificationPaginatedResponse>>;
    public getProvisioningNotificationBillingOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'saasTransactionId' | 'action' | 'sku' | 'serialNumber' | 'subscriptionType' | 'pla' | 'serviceStartDate' | 'serviceEndDate' | 'erpCustAcctNumber' | 'newTenantRequired' | 'tenantId' | 'countryCode' | 'information' | 'status', saasTransactionId?: string, action?: string, skuInfoOptionalQuerySku?: string, serialNumberQueryParamOptional?: string, subscriptionTypeQueryParamOptional?: string, pla?: string, startDateStartOptionalQueryParam?: string, startDateEndOptionalQueryParam?: string, endDateStartOptionalQueryParam?: string, endDateEndOptionalQueryParam?: string, erpCustAcctNumber?: string, countryCode?: string, newTenantRequired?: string, orgId?: string, information?: string, status?: ProvisioningNotificationStatusEnum, sourceType?: ProvisioningNotificationSourceTypeEnum, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getProvisioningNotificationBillingOperator.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getProvisioningNotificationBillingOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>saasTransactionId, 'saas-transaction-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>action, 'action');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>skuInfoOptionalQuerySku, 'sku-info-optional-query-sku');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serialNumberQueryParamOptional, 'serial-number-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>subscriptionTypeQueryParamOptional, 'subscription-type-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pla, 'pla');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startDateStartOptionalQueryParam, 'startDateStartOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startDateEndOptionalQueryParam, 'startDateEndOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endDateStartOptionalQueryParam, 'endDateStartOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endDateEndOptionalQueryParam, 'endDateEndOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>erpCustAcctNumber, 'erpCustAcctNumber');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>countryCode, 'countryCode');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>newTenantRequired, 'newTenantRequired');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>information, 'information');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>status, 'status');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sourceType, 'sourceType');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/provisioning-notification`;
        return this.httpClient.request<ProvisioningNotificationPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Patch provisioning notification by id
     * Find and patch provisioning notification by id
     * @param provisioningNotificationQueryIdRequired Provisioning Notification Primary Key
     * @param billingProvisioningRequestPatchSpec Provisioning Notification patch spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchProvisioningNotificationBillingOperator(provisioningNotificationQueryIdRequired: number, billingProvisioningRequestPatchSpec: BillingProvisioningRequestPatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<ProvisioningNotificationResponse>;
    public patchProvisioningNotificationBillingOperator(provisioningNotificationQueryIdRequired: number, billingProvisioningRequestPatchSpec: BillingProvisioningRequestPatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProvisioningNotificationResponse>>;
    public patchProvisioningNotificationBillingOperator(provisioningNotificationQueryIdRequired: number, billingProvisioningRequestPatchSpec: BillingProvisioningRequestPatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProvisioningNotificationResponse>>;
    public patchProvisioningNotificationBillingOperator(provisioningNotificationQueryIdRequired: number, billingProvisioningRequestPatchSpec: BillingProvisioningRequestPatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (provisioningNotificationQueryIdRequired === null || provisioningNotificationQueryIdRequired === undefined) {
            throw new Error('Required parameter provisioningNotificationQueryIdRequired was null or undefined when calling patchProvisioningNotificationBillingOperator.');
        }
        if (billingProvisioningRequestPatchSpec === null || billingProvisioningRequestPatchSpec === undefined) {
            throw new Error('Required parameter billingProvisioningRequestPatchSpec was null or undefined when calling patchProvisioningNotificationBillingOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>provisioningNotificationQueryIdRequired, 'provisioning-notification-query-id-required');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/provisioning-notification`;
        return this.httpClient.request<ProvisioningNotificationResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: billingProvisioningRequestPatchSpec,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
